import { ChangeDetectorRef, Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { Categorie } from '../models/categorie.model';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActivateLoadingAction, ChangeTitleNav, DeactivateLoadingAction } from '../redux/ui.actions';
import { UnsetCategorieDoctorsAction } from '../redux/categories-doctors.actions';
import moment from 'moment';
import 'moment/locale/es.js';

import { MatDialog } from '@angular/material/dialog';
import { FiltersComponent, FiltersDialogState } from './filters/filters.component';
import { TimezoneComponent } from './timezone/timezone.component';
import { PdfModalComponent } from './pdf-modal/pdf-modal.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {

  catSuscription: Subscription = new Subscription();
  docSuscription: Subscription = new Subscription();
  uisubs: Subscription = new Subscription();
  userSubscription: Subscription = new Subscription();

  doctors = [];
  categories: Categorie[] = [];
  cat_Id;
  firstModal = true;
  isLoading = false;
  seleccionao = false;
  loadingCategories = true;
  loadingDoctors = false;
  doctorsLoaded = false;
  activeFilters: FiltersDialogState | null = null;
  private allCategories: Categorie[] = [];
  private currentUser: any = null;
  private requestedCategories = false;
  private doctorStoreInitialized = false;
  private destroyed = false;

  constructor(
    private store: Store<AppState>,
    private authService: AuthService,
    private router: Router,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    this.catSuscription = store.select('categories').subscribe(c => {
      const categories = c.data || [];
      console.log('CATEGORIES', categories)
      if(categories.length > 0) this.loadingCategories = false;
      this.allCategories = categories;
      this.applyUserCategoryAccess();
      console.log(c.data)
    });

    this.docSuscription = store.select('cdoctors').subscribe(cd =>{
      const a = [...(cd.data || [])];
      if(!this.doctorStoreInitialized){
        this.doctorStoreInitialized = true;
        return;
      }
      if(!this.cat_Id && a.length === 0) return;

      a.sort((doctorA, doctorB) => this.getDoctorSlotsCount(doctorB) - this.getDoctorSlotsCount(doctorA));
      this.doctors = a;
      this.loadingDoctors = false;
      this.doctorsLoaded = true;
      console.log(this.seleccionao)
      console.log('DOCTORES:', this.doctors);
      this.store.dispatch(new DeactivateLoadingAction());
      this.refreshView();
    })

    /**Timezone Validation */
    this.userSubscription = store.select("user").subscribe(user=>{
      const userData = user && user.data;
      console.log(user);
      this.currentUser = userData || null;
      this.applyUserCategoryAccess();
    })
   }

  ngOnInit() {
    this.loadingCategories = this.categories.length === 0;
    this.requestedCategories = true;
    this.authService.getSpecialities();
    setTimeout(() => {
      if(this.categories.length === 0) this.loadingCategories = false;
    }, 12000);

    this.uisubs = this.store.select('ui').subscribe( ui=>{
      this.isLoading = ui.isLoading;
    });

  }

  ngAfterViewInit(){
    this.ensureSelectedCategory();
  }

  goCategorie2(id,name){
    this.loadCategory(id, false);
  }

  goCategorie(id, name){
    this.loadCategory(id, true);
  }

  reset(){
    if(!this.cat_Id) return;

    if (this.hasActiveFilters) {
      this.applyFilters(this.activeFilters);
      return;
    }

    this.loadCategory(this.cat_Id, true);
  }

  toogleCard(id){
    console.log('categoria seleccionada', id)
  }

  private ensureSelectedCategory(){
    if(this.categories.length === 0) return;
    if(this.cat_Id && this.categories.some(category => Number(category.id) === Number(this.cat_Id))) return;

    const category = this.categories[0];
    if(!category || !category.id) return;

    this.loadCategory(category.id, false);
  }

  private applyUserCategoryAccess(): void {
    if(!this.hasCategoryAccessInfo()){
      this.categories = [];
      this.cat_Id = null;
      this.doctors = [];
      this.doctorsLoaded = false;
      this.loadingDoctors = false;
      this.loadingCategories = this.allCategories.length > 0;
      this.store.dispatch(new UnsetCategorieDoctorsAction());
      this.refreshView();
      return;
    }

    const visibleCategories = this.isNom035User()
      ? this.allCategories.filter(cat => this.isNom035Category(cat))
      : this.allCategories;

    const selectedCategoryStillVisible = visibleCategories.some(
      category => Number(category.id) === Number(this.cat_Id)
    );

    this.categories = visibleCategories;

    if(!selectedCategoryStillVisible) {
      this.cat_Id = null;
      this.doctors = [];
      this.doctorsLoaded = false;
      this.loadingDoctors = false;
      this.store.dispatch(new UnsetCategorieDoctorsAction());
    }

    this.ensureSelectedCategory();
    this.refreshView();
  }

  private hasCategoryAccessInfo(): boolean {
    const user = this.currentUser || this.authService.user || {};
    if(!user || !user.id) return false;

    const companyId = Number(user.company_id);
    if(companyId !== 2) return true;

    return this.hasOwnValue(user, 'nom_035') || this.hasOwnValue(user, 'gnp');
  }

  private hasOwnValue(source: any, key: string): boolean {
    return Object.prototype.hasOwnProperty.call(source, key) && source[key] !== null && source[key] !== undefined;
  }

  private loadCategory(id, userSelected: boolean){
    if(!id) return;

    this.seleccionao = userSelected;
    this.cat_Id = id;
    this.doctors = [];
    this.doctorsLoaded = false;
    this.loadingDoctors = true;

    if (this.hasActiveFilters && this.activeFilters) {
      this.applyFilters(this.activeFilters);
      return;
    }

    this.authService.getDoctors(id);
  }

  get hasActiveFilters(): boolean {
    return !!this.activeFilters && this.filterCount > 0;
  }

  get filterCount(): number {
    if (!this.activeFilters) return 0;

    let count = 0;
    if (this.activeFilters.nombre?.trim()) count++;
    if (this.activeFilters.genero) count++;
    if (this.activeFilters.daysSelected?.length > 0) count++;
    if (this.activeFilters.horaInicio !== 9 || this.activeFilters.horaInicioIsPm) count++;
    if (this.activeFilters.horaFin !== 7 || !this.activeFilters.horaFinIsPm) count++;
    return count;
  }

  get activeFiltersLabel(): string {
    if (!this.activeFilters) return '';

    const parts: string[] = [];
    if (this.activeFilters.nombre?.trim()) parts.push(`Nombre: ${this.activeFilters.nombre.trim()}`);
    if (this.activeFilters.genero) parts.push(`Género: ${this.activeFilters.genero === 'female' ? 'Femenino' : 'Masculino'}`);
    if (this.activeFilters.daysSelected?.length > 0) parts.push(`${this.activeFilters.daysSelected.length} día(s)`);
    if (this.activeFilters.horaInicio || this.activeFilters.horaFin) {
      const start = this.formatFilterHour(this.activeFilters.horaInicio, this.activeFilters.horaInicioIsPm);
      const end = this.formatFilterHour(this.activeFilters.horaFin, this.activeFilters.horaFinIsPm);
      parts.push(`Horario: ${start} - ${end}`);
    }

    return parts.length > 0 ? parts.join(' · ') : 'Filtros activos';
  }

  get isHomeLoading(): boolean {
    return this.loadingCategories || this.loadingDoctors;
  }

  get activeCategory(): Categorie | null {
    return this.categories.find((category) => Number(category.id) === Number(this.cat_Id)) || null;
  }

  get activeCategoryName(): string {
    return this.activeCategory?.name || 'Categoría';
  }

  get doctorsCountLabel(): string {
    const count = this.doctors.length;
    return `${count} ${count === 1 ? 'disponible' : 'disponibles'} en esta categoría`;
  }

  getDoctorSummary(doctor): string {
    const description = (doctor?.user_description || '').trim();
    return description || 'Perfil disponible para agendar una sesión de apoyo.';
  }

  private isNom035User(): boolean {
    const user = this.currentUser || this.authService.user || {};
    const companyId = Number(user.company_id);
    const isNom035 = user.nom_035 === true || user.nom_035 === 1 || user.nom_035 === 'true' || user.nom_035 === '1';
    const isGnp = user.gnp === true || user.gnp === 1 || user.gnp === 'true' || user.gnp === '1';

    return companyId === 2 && isNom035 && !isGnp;
  }

  private isNom035Category(category: Categorie): boolean {
    if (Number(category.id) === 6) return true;

    const normalizedName = `${category.name || ''} ${category.cat_name || ''}`.toUpperCase().replace(/\s+/g, '');
    return normalizedName.includes('NOM035');
  }

  getCategoryImage(category: Categorie): string {
    const image = category.image_media_id as any;

    if (image && image.url) return image.url;
    if (typeof image === 'string') return image;

    return './assets/icono.png';
  }

  getDoctorPhoto(doctor): string {
    return this.getMediaUrl(doctor && doctor.photo_media_id, './assets/img/profile.jpg');
  }

  getResumeUrl(doctor): string {
    return this.getMediaUrl(doctor && doctor.resume_media_id, '');
  }

  hasResume(doctor): boolean {
    return !!this.getResumeUrl(doctor);
  }

  getReviewCount(doctor): number {
    const rawCount = doctor?.total_reviews
      ?? doctor?.total_review
      ?? doctor?.totalReviews
      ?? doctor?.reviewsTotal
      ?? doctor?.reviews_total
      ?? doctor?.reviews_count
      ?? doctor?.reviewsCount
      ?? doctor?.review_count
      ?? doctor?.reviewCount
      ?? doctor?.rating_count
      ?? doctor?.ratings_count
      ?? doctor?.reviews?.length
      ?? 0;
    const count = Number(rawCount);

    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  getReviewLabel(doctor): string {
    const count = this.getReviewCount(doctor);
    return `${count} ${count === 1 ? 'reseña' : 'reseñas'}`;
  }

  getDoctorRating(doctor): number {
    const rawRating = doctor?.average_reviews
      ?? doctor?.averageReviews
      ?? doctor?.average_review
      ?? doctor?.averageReview
      ?? doctor?.average_score
      ?? doctor?.averageScore
      ?? doctor?.reviews_average
      ?? doctor?.reviewsAverage
      ?? doctor?.rating
      ?? doctor?.score
      ?? doctor?.stars
      ?? 0;
    const rating = Number(rawRating);

    if (!Number.isFinite(rating) || rating <= 0) return 0;
    return Math.min(5, Math.round(rating * 10) / 10);
  }

  getDoctorRatingLabel(doctor): string {
    const rating = this.getDoctorRating(doctor);
    return Number.isInteger(rating) ? `${rating}` : rating.toFixed(1);
  }

  getExperienceLabel(doctor): string {
    const experience = this.formatDate(doctor && doctor.working_since);
    return experience ? `${experience} exp` : 'Experiencia no disponible';
  }

  getPrimarySpecialty(doctor): string {
    const services = doctor && doctor.services;
    return Array.isArray(services) && services.length > 0 && services[0]?.name
      ? services[0].name
      : 'Especialidad no disponible';
  }

  private getMediaUrl(media, fallback: string): string {
    if (media && media.url) return media.url;
    if (typeof media === 'string') return media;
    return fallback;
  }

  private getDoctorSlotsCount(doctor): number {
    return Array.isArray(doctor && doctor.time_slots) ? doctor.time_slots.length : 0;
  }

  private refreshView(): void {
    setTimeout(() => {
      if(!this.destroyed) this.cdr.detectChanges();
    });
  }

  bookingNow(id){
    const selectedDoctor = this.doctors.find((doctor) => Number(doctor.id) === Number(id));
    this.router.navigate(['panel/booking-now', id, this.cat_Id], {
      state: {
        doctor: selectedDoctor || null
      }
    });
  }

  ngOnDestroy(){
    this.destroyed = true;
    this.doctors = [];
    this.catSuscription.unsubscribe();
    this.docSuscription.unsubscribe();
    this.uisubs.unsubscribe();
    this.userSubscription.unsubscribe();
    this.store.dispatch( new ChangeTitleNav( "" ) );
    this.store.dispatch( new UnsetCategorieDoctorsAction())

  }

  formatDate(d){
    if(!d) return '';
    let date = new Date(d)
    if(Number.isNaN(date.getTime())) return '';
    return moment(date, "YYYYMMDD").fromNow(true);
  }

  // filters
  openFilters() {
    const dialogRef = this.dialog.open(FiltersComponent, {
      width: '1000px',
      height: '720px',
      data: { filters: this.activeFilters }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      if (result.action === 'clear') {
        this.clearFilters();
        return;
      }

      if (result.action === 'search') {
        this.applyFilters(result.filters);
      }
    });
  }

  clearFilters(): void {
    this.activeFilters = null;
    this.doctors = [];
    this.loadingDoctors = true;
    this.doctorsLoaded = false;
    this.store.dispatch(new ActivateLoadingAction());
    this.authService.getDoctors(this.cat_Id);
  }

  private applyFilters(filters: FiltersDialogState): void {
    if (!filters) {
      this.clearFilters();
      return;
    }

    const normalizedFilters: FiltersDialogState = {
      nombre: filters.nombre || '',
      genero: filters.genero || null,
      horaInicio: Number(filters.horaInicio ?? 9),
      horaInicioIsPm: !!filters.horaInicioIsPm,
      horaFin: Number(filters.horaFin ?? 7),
      horaFinIsPm: !!filters.horaFinIsPm,
      daysSelected: Array.isArray(filters.daysSelected) ? [...filters.daysSelected] : [],
    };

    this.activeFilters = normalizedFilters;
    this.doctors = [];
    this.loadingDoctors = true;
    this.doctorsLoaded = false;

    const startAt = moment().startOf('month').format('YYYY-MM-DD');
    const endAt = moment().endOf('month').format('YYYY-MM-DD');
    const start = `${normalizedFilters.horaInicio}:00:00`;
    const end = `${normalizedFilters.horaFin}:00:00`;
    const fechaInicio = normalizedFilters.daysSelected.length > 0
      ? normalizedFilters.daysSelected[0]
      : startAt;
    const fechaFin = normalizedFilters.daysSelected.length > 0
      ? normalizedFilters.daysSelected[normalizedFilters.daysSelected.length - 1]
      : endAt;

    const data = {
      startDate: `${fechaInicio} ${start}`,
      endDate: `${fechaFin} ${end}`,
      searchTerm: normalizedFilters.nombre ? normalizedFilters.nombre : '',
      gender: normalizedFilters.genero ? normalizedFilters.genero : '',
      users: this.cat_Id
    };

    this.store.dispatch(new ActivateLoadingAction());
    this.authService.getDoctorsFilter(data);
  }

  private formatFilterHour(hour: number, isPm: boolean): string {
    const normalizedHour = Number(hour);
    const suffix = isPm ? 'PM' : 'AM';
    return `${normalizedHour} ${suffix}`;
  }

  openConfigTimeZone(resultTimeZone){
    const dialogRef = this.dialog.open(TimezoneComponent,{
      width: '1000px',
      height: '780px',
      data: { data: resultTimeZone }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.authService.editProfile({timezone_validated:true},this.authService.user.id).subscribe({
          next:()=>{
            alert("Se cerrara tu sesión para aplicar los cambios.")
            this.authService.logout()
          },
          error:()=>{}
        })
         /*let startAt =(moment().startOf('month').format('YYYY-MM-DD'));
         let endAt = (moment().endOf('month').format('YYYY-MM-DD'));
         let start = `${result.horaInicio}:00:00`;
         let end = `${result.horaFin}:00:00`;
        
        let startDate = result.fechaInicio ? `${result.fechaInicio} ${start}` : `${startAt} ${start}`; 
        let endDate = result.fechaFin ? `${result.fechaFin} ${end}` : `${endAt} ${end}`; 
        let data = {
          startDate:startDate,
          endDate:endDate,
          searchTerm:result.nombre ? result.nombre: "",
          gender:result.genero ? result.genero: "",
          users:this.cat_Id
        }
        console.log(data)
        // return;
        this.store.dispatch(new ActivateLoadingAction());
        this.authService.getDoctorsFilter(data);*/
      }
    });
  }

  setDefaultPic(event){
    event.target.src = './assets/icono.png';
  }

  openPdfModal(link:string): void {
    const dialogRef = this.dialog.open(PdfModalComponent, {
      width: '100%',
      height: '70%',
      position: {
        top:'10%'
      },
      data: {
        pdfLink: link, // Reemplaza con tu enlace web del PDF
      },
    });
  }
}
